import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default new Map([['1', {
  com: function com() {
    return import('./on-job-en.vue');
  },
  lang: 'en',
  key: '1853'
}], ['2', {
  com: function com() {
    return import('./on-job-th.vue');
  },
  lang: 'th',
  key: '1851'
}], ['3', {
  com: function com() {
    return import('./wage-en.vue');
  },
  lang: 'en',
  key: '1857'
}], ['4', {
  com: function com() {
    return import('./wage-th.vue');
  },
  lang: 'th',
  key: '1854'
}], ['5', {
  com: function com() {
    return import('./obtain-en.vue');
  },
  lang: 'en',
  key: '1862'
}], ['6', {
  com: function com() {
    return import('./obtain-th.vue');
  },
  lang: 'th',
  key: '1859'
}]]);